import React, { Fragment, useState } from "react";
import { filter, length } from "ramda";
import updateArrangementsPrice from "module/functions/updateArrangementsPrice";
import updateArrangementsPriceWithoutDiscount from "module/functions/updateArrangementsPriceWithoutDiscount";
import updateArrangementsDiscount from "module/functions/updateArrangementsDiscount";
import Arrangement from "./arrangement/arrangement";

const GarmentArrangement = (props) => {
  const {
    form,
    register,
    setSelectValue,
    defaultValue,
    errors,
    jPath,
    setArrangementsPrice,
    setArrangementsPriceWithoutDiscount,
    setArrangementsDiscount,
    optionsAllowed,
    setOnFocus,
    windowSize,
    isMobileBrowser,
    isHidden,
  } = props;
  const [numberItems, setNumberItems] = useState([0]);

  const addItem = () => {
    const lastNumberItem = numberItems[length(numberItems) - 1];
    setNumberItems([...numberItems, lastNumberItem + 1]);
    setTimeout(() => {
      setSelectValue(`${jPath}.arrangement_group[${lastNumberItem + 1}].arrangement_group.arrangement.value`, []);
    }, 200);
  };

  const deleteItem = (index) => {
    setNumberItems(filter((i) => i !== index, numberItems));
    setTimeout(() => {
      setSelectValue("", "");
      setArrangementsPrice(updateArrangementsPrice());
      if (form.withDiscount) {
        setArrangementsPriceWithoutDiscount(updateArrangementsPriceWithoutDiscount());
        setArrangementsDiscount(updateArrangementsDiscount());
      }
    }, 200);
  };

  return (
    <Fragment>
      {numberItems.map((t, i) => (
        <Arrangement
          key={`t-${t}-${jPath}`}
          index={t}
          form={form}
          register={register}
          setSelectValue={setSelectValue}
          defaultValue={defaultValue}
          errors={errors}
          deleteItem={() => deleteItem(t)}
          indexToShow={i + 1}
          jPath={jPath}
          setArrangementsPrice={setArrangementsPrice}
          setArrangementsPriceWithoutDiscount={setArrangementsPriceWithoutDiscount}
          setArrangementsDiscount={setArrangementsDiscount}
          optionsAllowed={optionsAllowed}
          setOnFocus={setOnFocus}
          addItem={addItem}
          isLast={length(numberItems) === i + 1}
          windowSize={windowSize}
          isMobileBrowser={isMobileBrowser}
          isHidden={isHidden}
        />
      ))}
    </Fragment>
  );
};

export default GarmentArrangement;
